import React, { useContext, useEffect, useState } from "react";
import { Modal, Form, Button } from "react-bootstrap";
import Swal from "sweetalert2";
import useApi from "../../../hooks/useApi";
import { useMenuManagement } from "../../../context/MenuManagementContext";
import { createMenuItem, updateMenuItem } from "../../../services/adminApiService/menuApi/MenuApiService";
import { iconOptions } from "../../../utils/iconOptions";
import { AccountManagementContext } from "../../../context/AccountManagementContext";
import { AuthContext } from "../../../context/AuthContext";
import swal from "sweetalert";

const AddMenuManagement = ({
  show,
  handleClose,
  type = "create",
  initialData,
  perPage,
  currentPage,
  setCurrentPage
}) => {
  const { menuDataList, fetchMenuList, fetchMenuListById, menuListById, menuId, fetchSidebarMenuList, sideabarmenuDataList } = useMenuManagement();
  const { user, USER_LEVEL, userData } = useContext(AuthContext);
  const isDSORole = user?.role === "admin" && user?.user_level == USER_LEVEL.SUB_ADMIN


  const {
    accountUserAssingData,
    fetchAccountuserAssignRole,
  } = useContext(AccountManagementContext);


  const { request } = useApi();

  const [formData, setFormData] = useState({
    menu_type: "",
    title: "",
    parent_id: "",
    icon: "",
    url: "",
    sort_order: "",
    is_active: true,
    role_id: "",
    is_externalUrl:""
  });
  

  const [errors, setErrors] = useState({});
  const [submitting, setSubmitting] = useState(false);
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    let newValue = type === "checkbox" ? checked : value;
    // 🔹 Prevent non-numeric in sort_order
    if (name === "sort_order") {
      newValue = newValue.replace(/[^0-9]/g, "");
    }

    setFormData((prev) => ({
      ...prev,
      [name]: newValue,
    }));

    // 🔹 Real-time validation
    setErrors((prevErrors) => {
      const updatedErrors = { ...prevErrors };

      switch (name) {
        case "title":
          if (!newValue.trim()) {
            updatedErrors.title = "Title is required";
          } else if (!/^[A-Za-z\s]+$/.test(newValue)) {
            updatedErrors.title =
              "Title must contain only letters and spaces";
          } else {
            delete updatedErrors.title;
          }
          break;

        case "parent_id":
          if (!newValue.trim()) {
            updatedErrors.parent_id = "Please select parent menu";
          } else {
            delete updatedErrors.parent_id;
          }
          break;

        case "role_id":
          if (!newValue.trim()) {
            updatedErrors.role_id = "Please select role";
          } else {
            delete updatedErrors.role_id;
          }
          break;

        case "icon":
          if (formData.menu_type === "parent") {
            if (!newValue.trim()) {
              updatedErrors.icon = "Icon is required";
            } else {
              delete updatedErrors.icon;
            }
          } else {
            delete updatedErrors.icon; // remove error if child selected
          }
          break;

        case "url":
          if (formData.menu_type === "child") {
            const slugPattern =
              /^(https?:\/\/[a-zA-Z0-9.-]+(\.[a-zA-Z]{2,})(\/.*)?|[A-Za-z]+(-[A-Za-z]+)*(\/[A-Za-z]+(-[A-Za-z]+)*)*)$/;

            if (!newValue.trim()) {
              updatedErrors.url = "URL is required";
            } else if (!slugPattern.test(newValue)) {
              updatedErrors.url =
                "Only letters, hyphen (-), and forward slash (/) allowed.";
            } else {
              delete updatedErrors.url;
            }
          } else {
            delete updatedErrors.url; // remove error if parent selected
          }
          break;

        case "sort_order":
          if (!newValue) {
            updatedErrors.sort_order = "Sort order is required";
          } else if (Number(newValue) <= 0) {
            updatedErrors.sort_order =
              "Sort order must be greater than 0";
          } else {
            delete updatedErrors.sort_order;
          }
          break;

        default:
          break;
      }

      return updatedErrors;
    });
  };
  const validateForm = () => {
    const newErrors = {};

    if (!formData.title.trim()) {
      newErrors.title = "Title is required";
    }

    if (formData.menu_type === "child" && !formData.parent_id) {
      newErrors.parent_id = "Please select parent menu";
    }

    if (isDSORole && !formData.role_id?.trim()) {
      newErrors.role_id = "Please select role";
    }

    if (formData.menu_type === "parent") {
      if (!formData.icon.trim()) {
        newErrors.icon = "Icon is required";
      }
    }

    const slugPattern = /^[A-Za-z]+(-[A-Za-z]+)*(\/[A-Za-z]+(-[A-Za-z]+)*)*$/;

    if (formData.menu_type === "child") {
      const slugPattern =
       /^(https?:\/\/[a-zA-Z0-9.-]+(\.[a-zA-Z]{2,})(\/.*)?|[A-Za-z]+(-[A-Za-z]+)*(\/[A-Za-z]+(-[A-Za-z]+)*)*)$/;

      if (!formData.url.trim()) {
        newErrors.url = "URL is required";
      } else if (!slugPattern.test(formData.url)) {
        newErrors.url =
          "Only letters, hyphen (-), and forward slash (/) allowed.";
      }
    }

    if (!formData.sort_order) {
      newErrors.sort_order = "Sort order is required";
    } else if (Number(formData.sort_order) <= 0) {
      newErrors.sort_order = "Sort order must be greater than 0";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  useEffect(() => {
    if (type === "edit" && menuListById) {
      const isSubMenu = menuListById?.parent_id !== null && menuListById?.parent_id !== undefined;
      // console.log("menuListById=======>",menuListById.is_externalUrl)
      setFormData({
        title: menuListById?.title || "",
        parent_id: menuListById?.parent_id || "",
        role_id: menuListById?.role_id || "",
        icon: menuListById?.icon || "",
        url: menuListById.url || "",
        sort_order: menuListById.sort_order || "",
        is_active:
          menuListById.is_active !== undefined
            ? menuListById.is_active
            : true,
        menu_type: isSubMenu ? "child" : "parent",
        is_externalUrl:menuListById?.is_externalUrl
       
      });
    }
  }, [type, menuListById]);



  useEffect(() => {
    fetchAccountuserAssignRole();
  }, []);

  useEffect(() => {
    fetchMenuListById(menuId);
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) return;

    const payload = {
      ...formData,
      parent_id: formData.parent_id
        ? Number(formData.parent_id)
        : null,
      sort_order: Number(formData.sort_order),
      role_id: Number(formData.role_id),
      is_externalUrl:formData.is_externalUrl
    };

    try {
      setSubmitting(true);
      setErrors({});

      let response;

      if (type === "create") {
        response = await request(() => createMenuItem(payload));
      } else {
        response = await request(() =>
          updateMenuItem(menuId, payload)
        );
      }

      if (response?.data?.status === true) {
        // await Swal.fire({
        //   icon: "success",
        //   title: "Success",
        //   text: response?.data?.message || "Saved successfully",
        // });
        swal("Success", response?.data?.message, "success");
        setCurrentPage(1);
       await fetchMenuList(perPage, 1);
        fetchSidebarMenuList(); // refresh listing
        handleClose();
      } else {
        // backend validation errors (handles both `errors` and object `message`)
        if (
          response?.data?.errors ||
          (typeof response?.data?.message === "object" &&
            response?.data?.message !== null)
        ) {
          const backendErrors =
            response.data.errors || response.data.message;

          const formattedErrors = {};

          Object.keys(backendErrors).forEach((field) => {
            formattedErrors[field] = backendErrors[field][0];
          });

          setErrors(formattedErrors);
        } else {
          Swal.fire({
            icon: "error",
            title: "Error",
            text:
              response?.data?.message ||
              "Something went wrong",
          });
        }
      }
    } catch (error) {
      if (error.response?.data?.errors) {
        const backendErrors = error.response.data.errors;
        const formattedErrors = {};

        Object.keys(backendErrors).forEach((field) => {
          formattedErrors[field] = backendErrors[field][0];
        });

        setErrors(formattedErrors);
      } else {
        Swal.fire({
          icon: "error",
          title: "Error",
          text:
            error.response?.data?.message ||
            "Unexpected error occurred",
        });
      }
    } finally {
      setSubmitting(false);
    }
  };

  /* =============================
        CHECK FORM VALIDITY
  ============================== */
  const isFormValid =
    formData.title.trim() &&
    Number(formData.sort_order) > 0 &&
    Object.keys(errors).length === 0 &&
    (
      formData.menu_type === "parent"
        ? formData.icon.trim()
        : formData.menu_type === "child"
          ? formData.url.trim()
          : false
    );

  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>
          {type === "create" ? "Add Menu" : "Update Menu"}
        </Modal.Title>
      </Modal.Header>

      <Form onSubmit={handleSubmit}>
        <Modal.Body>
          <Form.Group className="mb-3">
            <Form.Label>Menu Type <span className="text-danger">*</span></Form.Label>
            <Form.Select
              name="menu_type"
              value={formData.menu_type}
              onChange={handleChange}
              style={{ backgroundColor: "transparent" }}
            >
              <option value="">Select Type</option>
              <option value="parent">Parent Menu</option>
              <option value="child">Sub Menu</option>
            </Form.Select>
          </Form.Group>

          {/* Parent Menu */}
          {formData.menu_type === "child" && (
            <Form.Group className="mb-3">
              <Form.Label>Parent Menu<span className="text-danger">*</span></Form.Label>
              <Form.Select
                name="parent_id"
                value={formData.parent_id}
                onChange={handleChange}
                isInvalid={!!errors.parent_id}
                style={{ backgroundColor: "transparent" }}
              >
                <option value="">Select Parent</option>

                {sideabarmenuDataList?.data?.map((menu) => (
                  <option key={menu?.id} value={menu?.id}>
                    {menu?.title}
                  </option>
                ))}
              </Form.Select>
              <Form.Control.Feedback type="invalid">
                {errors.parent_id}
              </Form.Control.Feedback>
            </Form.Group>
          )}

          {/* Title */}
          <Form.Group className="mb-3">
            <Form.Label>{formData.menu_type === "child" ? "Sub Menu" : "Parent"} Title <span className="text-danger">*</span></Form.Label>
            <Form.Control
              type="text"
              name="title"
              value={formData.title}
              onChange={handleChange}
              isInvalid={!!errors.title}
            />
            <Form.Control.Feedback type="invalid">
              {errors.title}
            </Form.Control.Feedback>
          </Form.Group>



          {/* Role Menu */}
          {isDSORole && (
            <Form.Group className="mb-3">
              <Form.Label>Role<span className="text-danger">*</span></Form.Label>
              <Form.Select
                name="role_id"
                value={formData.role_id}
                onChange={handleChange}
                isInvalid={!!errors.role_id}
                style={{ backgroundColor: "transparent" }}
              >
                <option value="">Select Role</option>

                {accountUserAssingData?.data?.map((item) => (
                  <option key={item?.id} value={item?.id}>
                    {item?.role_name}
                  </option>
                ))}
              </Form.Select>
              <Form.Control.Feedback type="invalid">
                {errors.role_id}
              </Form.Control.Feedback>
            </Form.Group>
          )}


          {/* Icon */}
          {formData.menu_type === "parent" && (
            <Form.Group className="mb-3">
              <Form.Label>Icon<span className="text-danger">*</span></Form.Label>

              <Form.Select
                name="icon"
                value={formData.icon}
                onChange={handleChange}
                isInvalid={!!errors.icon}
                style={{ backgroundColor: "transparent" }}
              >
                <option value="">Select Icon</option>

                {iconOptions.map((icon) => (
                  <option key={icon} value={icon}>
                    {icon}
                  </option>
                ))}
              </Form.Select>

              {formData.icon && (
                <div className="mt-2">
                  Preview: <i className={formData.icon}></i>
                </div>
              )}

              <Form.Control.Feedback type="invalid">
                {errors.icon}
              </Form.Control.Feedback>
            </Form.Group>
          )}



          {/* URL */}
          {formData.menu_type === 'child' && (
            <Form.Group className="mb-3">
              <Form.Label>URL<span className="text-danger">*</span></Form.Label>
              <Form.Control
                type="text"
                name="url"
                value={formData.url}
                onChange={handleChange}
                isInvalid={!!errors.url}
              />
              <Form.Control.Feedback type="invalid">
                {errors.url}
              </Form.Control.Feedback>
            </Form.Group>

          )}


          {/* Sort Order */}
          <Form.Group className="mb-3">
            <Form.Label>Sort Order <span className="text-danger">*</span></Form.Label>
            <Form.Control
              type="text"
              name="sort_order"
              value={formData.sort_order}
              onChange={handleChange}
              isInvalid={!!errors.sort_order}
            />
            <Form.Control.Feedback type="invalid">
              {errors.sort_order}
            </Form.Control.Feedback>
          </Form.Group>

          {/* Is Active */}
          <Form.Check
            type="checkbox"
            label="Is Active"
            name="is_active"
            checked={formData.is_active}
            onChange={handleChange}
            className="mb-2"
          />
          {formData.menu_type === 'child' && (
           <Form.Check
            type="checkbox"
            label="External Url"
            name="is_externalUrl"
            checked={formData.is_externalUrl}
            onChange={handleChange}
            className="mb-2"
          />
          )}
           
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Cancel
          </Button>

          <Button
            type="submit"
            variant="primary"
            disabled={!isFormValid || submitting}
          >
            {submitting
              ? "Please wait..."
              : type === "create"
                ? "Create"
                : "Update"}
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default AddMenuManagement;